export function packageTotal(pkg: {
  lineItems: { quantity: number | null; unitCost: number }[];
  additionalCharges: { amount: number }[];
}): number {
  const lineTotal = pkg.lineItems.reduce(
    (sum, li) => sum + (li.quantity != null ? li.quantity * li.unitCost : li.unitCost),
    0,
  );
  const chargeTotal = pkg.additionalCharges.reduce((sum, c) => sum + c.amount, 0);
  return lineTotal + chargeTotal;
}

export function quoteDisplayTotal(quote: {
  packages: {
    isSelected: boolean;
    lineItems: { quantity: number | null; unitCost: number }[];
    additionalCharges: { amount: number }[];
  }[];
  addOns?: { quantity: number | null; unitCost: number }[];
  additionalCharges?: { amount: number }[];
}): { total: number; min: number; max: number; isRange: boolean } {
  const aoTotal = (quote.addOns ?? []).reduce(
    (sum, ao) => sum + (ao.quantity != null ? ao.quantity * ao.unitCost : 0),
    0,
  );
  const quoteChargeTotal = (quote.additionalCharges ?? []).reduce(
    (sum, ch) => sum + ch.amount,
    0,
  );
  const base = aoTotal + quoteChargeTotal;
  const selected = quote.packages.filter((pkg) => pkg.isSelected);
  if (selected.length > 0) {
    const total = selected.reduce((sum, pkg) => sum + packageTotal(pkg), 0) + base;
    return { total, min: total, max: total, isRange: false };
  }
  const totals = quote.packages.map(packageTotal);
  if (totals.length <= 1) {
    const total = (totals[0] ?? 0) + base;
    return { total, min: total, max: total, isRange: false };
  }
  const min = Math.min(...totals) + base;
  const max = Math.max(...totals) + base;
  return { total: 0, min, max, isRange: min !== max };
}
